// extracted by mini-css-extract-plugin
module.exports = {"root":"ZFLjfrq5","icon":"geXlh_oC","next":"bK1Gh7tE"};